//src/components/Staff/AgencyAssignmentHistory.jsx

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AgencyAssignmentHistory = () => {
  const [records, setRecords] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await axios.get('/api/agency/assignment-history');
        setRecords(res.data || []);
      } catch (err) {
        console.error('Error fetching agency history:', err);
        setMessage('Failed to load agency assignment records.');
      }
    };

    fetchHistory();
  }, []);

  return (
    <div className="bg-[#0f172a] p-6 rounded-2xl shadow-xl border border-[#334155] text-white">
      <h2 className="text-xl font-bold mb-4">📜 Agency Assignment History</h2>

      {message && <p className="text-yellow-400 font-medium">{message}</p>}

      {records.length === 0 ? (
        <p className="text-gray-400 text-sm">No agency assignments recorded yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border-collapse">
            <thead>
              <tr className="bg-[#1e293b] text-slate-300 uppercase text-xs">
                <th className="px-4 py-2 text-left">Date</th>
                <th className="px-4 py-2 text-left">Role</th>
                <th className="px-4 py-2">Agency</th>
                <th className="px-4 py-2">Staff Booked</th>
                <th className="px-4 py-2">Contact</th>
                <th className="px-4 py-2">Response Time</th>
                <th className="px-4 py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {records.map((row, i) => (
                <tr
                  key={i}
                  className={`${i % 2 === 0 ? 'bg-[#111827]' : 'bg-[#1f2937]'} hover:bg-[#2d3748]/50 transition`}
                >
                  <td className="px-4 py-2">{row.date}</td>
                  <td className="px-4 py-2">{row.role}</td>
                  <td className="px-4 py-2 text-center">{row.agency_name}</td>
                  <td className="px-4 py-2 text-center">{row.booked_staff_name}</td>
                  <td className="px-4 py-2 text-center">{row.booked_staff_contact}</td>
                  <td className="px-4 py-2 text-center">{row.response_time}</td>
                  <td className="px-4 py-2 text-center">
                    <span
                      className={`text-xs px-2 py-1 rounded ${
                        row.status === 'Confirmed'
                          ? 'bg-green-700 text-green-300'
                          : row.status === 'Pending'
                          ? 'bg-yellow-700 text-yellow-300'
                          : 'bg-red-700 text-red-300'
                      }`}
                    >
                      {row.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AgencyAssignmentHistory;
